<template>
  <div class="row">
    <div
      v-for="platform in platforms"
      :key="`platform_${platform.id}`"
      class="col-12 mb-4"
    >
      <div class="row align-items-center">
        <TextLabel class="col-12 mb-3" variant="caption">
          {{ platform.name }}
        </TextLabel>

        <ListItem
          class="col-12 platform-item-wrapper"
          :avatar-props="{
            imgUrl: (platform.logo && platform.logo.uri) || '',
            size: 40,
            type: 'platform',
          }"
        >
          <template slot="title">
            <span
              v-if="!isPlatformFavorite(platform)"
              class="text-muted font-size-sm"
            >
              {{
                $$t('Not connected to {platform}', { platform: platform.name })
              }}
            </span>
            <div v-else class="h-mr-4 row no-gutters">
              <div class="col col-md-6">
                <TextInput
                  :placeholder="$$t('Username on platform')"
                  :value="value[platform.id]"
                  @change="
                    login =>
                      updatePlatformLogin({ platformID: platform.id, login })
                  "
                />
              </div>
            </div>
          </template>
          <template v-if="canBeLinked(platform)" slot="subtitle">
            <a href="#" class="mt-1">
              {{ $$t('Link your account') }}
            </a>
          </template>
          <template slot="tail">
            <BSwitch
              :value="isPlatformFavorite(platform)"
              @input="event => togglePlatform(platform.id, event)"
            />
          </template>
        </ListItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { translate } from '@/mixins/translate';
import BSwitch from '@/components/atoms/form/HeraFormSwitch';
import TextLabel from '@/components/atoms/TextLabel';
import ListItem from '@/components/common/ListItem';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
const availableToLinkPlatfroms = [
  // '005c93cc-afac-44be-b797-ef2d1c8c2b08', //PC
  // '9f4b2686-b0f7-4dc8-9786-8624218925c2', //PS4
];

export default {
  name: 'PlatformsSwitch',
  components: {
    ListItem,
    TextLabel,
    BSwitch,
    TextInput,
  },
  mixins: [translate('_web_platforms')],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['platforms']),
  },
  created() {
    this.fetchPlatforms();
  },
  methods: {
    ...mapActions(['fetchPlatforms', 'addLoginToPlatform']),
    canBeLinked(platform) {
      return availableToLinkPlatfroms.includes(platform.id);
    },
    isPlatformFavorite(platform) {
      return Object.keys(this.value).includes(platform.id);
    },
    togglePlatform(id, isChecked) {
      const checkedPlatforms = this.$lodash.cloneDeep(this.value);
      let needUpdate = true;
      if (isChecked) {
        if (this.isPlatformFavorite({ id })) {
          needUpdate = false;
        } else {
          checkedPlatforms[id] = '';
        }
      } else {
        delete checkedPlatforms[id];
      }
      if (needUpdate) {
        this.$emit('input', checkedPlatforms);
      }
    },
    updatePlatformLogin(payload) {
      this.$emit('input', {
        ...this.value,
        [payload.platformID]: payload.login,
      });
      this.addLoginToPlatform(payload);
    },
  },
};
</script>
<style lang="scss">
.platform-item-wrapper {
  align-items: flex-start !important;
}
</style>
